import Wrapper from '@app/Wrapper.js'

Munio.UserIndex = class extends Wrapper {
  constructor(selector) {
    super(selector, {
      roles: window.Munio.state.roles,
    })
  }

  component() {
    return import('./App.vue')
  }
}
